import React, { useEffect, useRef } from "react";
import sk from "../../localization/sk";
import PropTypes from "prop-types";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { useGridData } from "../GridDataContext";
import { ENUM_DEFAULT } from "../DataGrid";
import _ from "lodash";
import { HeaderThElement } from "@progress/kendo-react-data-tools";

// /**
//  * Dropdown filter cell component builder
//  * @module
//  * @param {string} defaultItem - Default value for dropdown
//  * @param {func} getColumns - Function to getColumns data
//  * @param {string} defaultValue - Default value for filter
//  */
// export const dropdownFilterCell = ({ defaultItem = "", getColumns }) => {
//   /**
//    * Dropdown filter cell component
//    * @Component
//    * @param {func} props.onChange - On change function
//    * @param {string} props.value - Value
//    * @param {string} props.field - field
//    */

const DropdownFilterCell = (props) => {
  const { onChange, thProps, schemaItem } = props;
  const { primaryField, textField, dataField, defaultItem: schemaDefaultItem } = schemaItem;
  const defaultItem = schemaDefaultItem ?? ENUM_DEFAULT;

  const dropDownRef = useRef(null);
  useEffect(() => {
    if (dropDownRef.current && dropDownRef.current.element && props.name) {
      dropDownRef.current.element.setAttribute('data-testid', props.name);
    }
  }, [props.name])

  const hasValue = (currentValue) => {
    return currentValue && currentValue !== defaultItem;
  };

  const handleChange = (event) => {
    const eventValue = hasValue(event.target.value) ? (primaryField ? event.target.value[primaryField] : event.target.value) : defaultItem;
    onChange({
      value: eventValue,
      operator: hasValue(event.target.value) ? (eventValue === null ? "isempty" : "eq") : "",
      syntheticEvent: event.syntheticEvent,
    });
  };

  const data = useGridData(dataField)?.map(x => x[primaryField] === null ? { ...x, [textField]: "(" + sk.grid.filterIsNullOperator + ")" } : x);
  const filterValue = props.value;
  const dataItem = data?.find(x => x[primaryField] === (_.isNumber(filterValue) ? Number(filterValue) : filterValue));
  const dropDownValue = dataItem || filterValue || null;

  const element = <div className="k-filtercell">
    <div className={"k-filtercell-wrapper"}>
      <DropDownList
        data={data ?? []}
        onChange={handleChange}
        value={dropDownValue}
        defaultItem={{ [textField]: defaultItem }}
        textField={textField}
        ref={dropDownRef}
      />
    </div>
  </div>
  return thProps ? <HeaderThElement {...thProps} >{element}</HeaderThElement> : element;
};

DropdownFilterCell.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default DropdownFilterCell;
